module.exports = "/_next/static/videos/video-7995f6a848bea0b40c4c808db73d521f.mp4";